const capitaliseSentence = string => {
  const words = string.split(' ');
  let wordsCapitalised = '';
  for (let i = 0; i < words.length; i++) {
    wordsCapitalised += `${words[i].charAt(0).toUpperCase() + words[i].slice(1)} `;
  }
  return wordsCapitalised;
};

export default capitaliseSentence;



// WEBPACK FOOTER //
// ./src/utils/CapitaliseSentence.js